import React, { Component } from "react";
import A from "../a";
import "./styles.css";
import Wrap from "../wrap";
import AltLogo from "../alt-logo";
import menu from "./assets/menu.png";
import cross from "./assets/cross.png";

export default class StickyHeader extends Component {
  state = {
    drawerOpen: false,
  };

  componentWillReceiveProps(nextProps) {
    if (!nextProps.visible && this.state.drawerOpen) {
      this.setState({ drawerOpen: false });
    }
  }

  handleHamburgerClick = () => {
    this.setState((prevState) => ({
      drawerOpen: prevState.drawerOpen ? false : true,
    }));
  };

  render() {
    const {
      visible,
      authenticated,
      signOut,
      premium,
      affiliate,
      page,
      hideStickyAfterClick,
      home,
      signInWithGoogle,
    } = this.props;
    const { drawerOpen } = this.state;

    let stickyClass;

    if (visible && drawerOpen) {
      stickyClass = "drawerOpen";
    } else if (visible) {
      stickyClass = "visible";
    } else {
      stickyClass = "";
    }
    return (
      <div className={home ? "sticky-header-fixed" : "sticky-header-normal"}>
        <div className={`sticky-header ${stickyClass}`}>
          <Wrap>
            <div
              className={`sticky-header-container ${
                drawerOpen ? "logoandmenu open" : "logoandmenu"
              }`}
            >
              <A href="/" className="logoandmenu-logo">
                <AltLogo className="logoandmenu-logo" />
              </A>
              {/* <img className="logo" src={Logo} /> */}
              <img
                className={`logoandmenu-menu ${
                  drawerOpen ? "logoandmenu-menu-hide" : ""
                }`}
                src={menu}
                onClick={() =>
                  this.setState({
                    drawerOpen: true,
                  })
                }
                alt="menu icon"
              />
              <img
                className={`logoandmenu-menu ${
                  drawerOpen ? "" : "logoandmenu-menu-hide"
                }`}
                src={cross}
                onClick={() =>
                  this.setState({
                    drawerOpen: false,
                  })
                }
                alt="menu icon"
              />
            </div>
            <div
              className={`sticky-header-drawer ${drawerOpen && "visible"}`}
              onClick={hideStickyAfterClick}
            >
              <nav>
                <div className={page === "features" ? "current-page" : ""}>
                  <A href="/#features">Features</A>
                </div>
                <div className={page === "howitworks" ? "current-page" : ""}>
                  <A href="/#howitworks">How it works?</A>
                </div>
                <div className={page === "testimonials" ? "current-page" : ""}>
                  <A href="/#testimonials">Testimonials</A>
                </div>{" "}
                {affiliate ? (
                  <div>
                    <A href="/affiliate">Affiliate</A>
                  </div>
                ) : null}
                {authenticated ? (
                  <div>
                    <A onClick={signOut}>Sign Out</A>
                  </div>
                ) : null}
                <div className="signinout">
                  {authenticated && premium ? (
                    <A href="/download">Download</A>
                  ) : authenticated ? (
                    <A href="#pricing">Buy Now</A>
                  ) : null}
                  {!authenticated ? (
                    <A onClick={signInWithGoogle}>Sign In</A>
                  ) : null}
                </div>
              </nav>
            </div>
          </Wrap>
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/components/stickyHeader/index.js
 **/